export { default } from './Home24HeroSimulacao';
